import dayjs from 'dayjs';
import React, { useState } from 'react'
import { useActionHistoryDetailsExcel, useShopReportDetailsPagination } from '../../../../API_Master/GetAPI';
import { NIGHT_EYE_IMG_URL } from '../../../../Process';
import PaginationButtons from '../../../../Components/PaginationButtons';
import PageEntries from '../../../../Components/PageEntries';
import { exportToExcel, notifyError, validateStartAndEndDate } from '../../../../HelperMethods';
import { useSelector } from 'react-redux';
import Flatpickr from "react-flatpickr";
import { format, subDays } from 'date-fns'; // ← recommended lightweight library
import PageCountSelect from '../../../../Components/PageCountSelect';
import { toast } from 'react-toastify';

const DetailsActionHistoryReport = ({ setIsModalOpen }) => {
    const { shopDetailID } = useSelector((state) => state.ProjectSlice);
    const [currentPage, setCurrentPage] = useState(0); // index: 0 = page 1
    const [selectedImage, setSelectedImage] = useState(null);
    const [filterData, setFilterData] = useState({

        shopDetailID: shopDetailID || "",
        startDate: subDays(new Date(), 7),   // 7 days back
        endDate: new Date(),
    })
    const [modelFilter, setModelFilter] = useState({

        shopDetailID: shopDetailID || "",
        startDate: subDays(new Date(), 7),   // 7 days back
        endDate: new Date(),
    })
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { data,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isLoading,
        isError,
        refetch
    } = useShopReportDetailsPagination(rowsPerPage, filterData);
    const {
        mutate: exportShopActionHistoeyDetails,
        isPending: isExporting
    } = useActionHistoryDetailsExcel();
    const pages = data?.pages || [];
    const totalCount = data?.pages[0]?.TotalCount || 0;
    const currentItems = data?.pages[currentPage]?.data || [];

    const start = currentPage * rowsPerPage + 1;
    const end = Math.min(start + currentItems.length - 1, totalCount);
    const handleFilterSearch = () => {

        if (!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate)) {
            return;
        }
        setFilterData(modelFilter)
    }

    const goToPage = async (index) => {
        if (pages[index]) {
            setCurrentPage(index);
        } else if (hasNextPage) {
            await fetchNextPage(); // loads next page
            setCurrentPage(index);
        }
    };
    const handleFilterDateChange = (e, name) => {
        setModelFilter((prev) => {
            return {
                ...prev,
                [name]: e?.[0]
            }
        })
    }
    const handleFilterCancel = () => {
        setModelFilter({
            ...modelFilter,
            startDate: subDays(new Date(), 7),   // 7 days back
            endDate: new Date(),
        })
        setFilterData({
            ...filterData,
            startDate: subDays(new Date(), 7),   // 7 days back
            endDate: new Date(),
        })
    }
    const openModal = (imageUrl) => {
        setSelectedImage(imageUrl);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };
    const handleRowsChange = async (e) => {
        const limit = parseInt(e.target.value);
        setRowsPerPage(limit);
        setCurrentPage(0);
        await refetch();  // reload from start
    };
    const handleExport = (exportType) => {
        toast.dismiss()
        exportShopActionHistoeyDetails(filterData, {
            onSuccess: (data) => {
                if (!data.length) {
                    // return alert('No Data Found')
                    return notifyError("No Data Found")
                }
                let exportData = data.map((item, index) => ({
                    "Sr No ": index + 1,
                    "Report Date": item?.ReportDate || "",
                    "Report Time": item?.ReportTime || "",
                    "Description": item?.Description || "",
                    "Police Station": item?.PoliceStation || ""
                }))
                exportToExcel(exportData, 'Action_History_Details_Excel');
            },
            onError: () => {
                // notifyError(" Export failed. Please try again.")
                return notifyError('Export failed. Please try again.');
            },
        });
    };
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
            <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-6xxl h-[90vh] flex flex-col overflow-hidden">
                {/* Header */}
                <div className="p-5 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
                    <h2 className="text-xl font-bold text-slate-900 dark:text-white">
                        Shop Action Detailed Report
                    </h2>
                    <button
                        onClick={() => setIsModalOpen(false)}
                        className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 text-2xl"
                    >
                        ×
                    </button>
                </div>

                {/* Filters */}

                <div className="p-4 border-b border-slate-200 dark:border-slate-700">
                    <div className="flex flex-wrap items-end gap-4 md:gap-6">
                        {/* Start Date */}
                        <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />
                        <div className="min-w-[220px] flex-1 md:flex-none">
                            <label htmlFor="startDate" className="block mb-1.5 text-sm font-medium text-gray-700 dark:text-gray-300">
                                Start Date
                            </label>
                            <Flatpickr
                                options={{ dateFormat: "d-m-Y" }}
                                value={modelFilter?.startDate}
                                id="startDate"
                                name="startDate"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/30 focus:border-primary outline-none transition-all dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder:text-slate-400"
                                onChange={(e) => handleFilterDateChange(e, "startDate")}
                                placeholder="DD-MM-YYYY"
                            />
                        </div>

                        {/* End Date */}
                        <div className="min-w-[220px] flex-1 md:flex-none">
                            <label htmlFor="endDate" className="block mb-1.5 text-sm font-medium text-gray-700 dark:text-gray-300">
                                End Date
                            </label>
                            <Flatpickr
                                options={{ dateFormat: "d-m-Y" }}
                                value={modelFilter?.endDate}
                                id="endDate"
                                name="endDate"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/30 focus:border-primary outline-none transition-all dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder:text-slate-400"
                                onChange={(e) => handleFilterDateChange(e, "endDate")}
                                placeholder="DD-MM-YYYY"
                            />


                        </div>

                        {/* Apply Button */}
                        <button
                            onClick={handleFilterSearch}
                            className="px-6 py-2 bg-primary text-white font-medium rounded-lg 
                 hover:bg-primary/90 active:bg-primary/80 
                 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 
                 transition-all shadow-sm"
                        >
                            Apply Filter
                        </button>
                        <button
                            onClick={handleFilterCancel}
                            className="px-6 py-2 bg-red-600 text-white font-medium rounded-lg 
             hover:bg-red-700 active:bg-red-800 
             focus:outline-none focus:ring-2 focus:ring-red-300 focus:ring-offset-2 
             transition-all shadow-sm"
                        >
                            Last 7 days
                        </button>
                        <button
                            onClick={handleExport}
                            className="px-6 py-2 bg-green-600 text-white font-medium rounded-lg 
             hover:bg-green-700 active:bg-green-800 
             focus:outline-none focus:ring-2 focus:ring-green-300 focus:ring-offset-2 
             transition-all shadow-sm"
                        >
                            Excel
                        </button>
                    </div>
                    {!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate) && (
                        <p className="mt-1.5 text-sm text-red-600 dark:text-red-400 font-medium">
                            End date cannot be earlier than start date
                        </p>
                    )}
                </div>

                {/* Table content */}
                <div className="flex-1 overflow-auto p-4">
                    {isLoading || isFetching ? (
                        <div className="text-center py-12 text-slate-500 dark:text-slate-400">Loading...</div>
                    ) :
                        data?.length === 0 ? (
                            <div className="text-center py-12 text-slate-500 dark:text-slate-400">
                                No records found for selected period
                            </div>
                        ) : (
                            <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
                                <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                                    <tr>
                                        <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                                            Sr No
                                        </th>
                                        <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                                            Report Date
                                        </th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                                            Report Time
                                        </th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                                            Description
                                        </th>

                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                                            Police Station
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                                    {pages[currentPage]?.data?.length ? pages[currentPage]?.data.map((track, idx) => {
                                        const absoluteIndex = currentPage * rowsPerPage + idx + 1;
                                        const imageUrl = track.Attachment
                                            ? `${NIGHT_EYE_IMG_URL}/SmartCollection/ShopDailyImage/${track.Attachment}`
                                            : null;
                                        return (
                                            <>
                                                <tr key={idx} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                                                        {absoluteIndex}
                                                    </td>
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                                                        {track.ReportDate}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                                        {track.ReportTime}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm">
                                                        {/* <span
                                                            className={`inline-flex items-center gap-1 rounded-md ${track.VarianceStatus === 'Early'
                                                                ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300'
                                                                : 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300'
                                                                } px-2 py-1 text-xs font-medium ring-1 ring-inset ring-slate-600/10`}
                                                        > */}
                                                        {track.Description}
                                                        {/* </span> */}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm">{track.PoliceStation}</td>
                                                    {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-right">
                                                        {track.Attachment && (
                                                            <div className="flex justify-end">
                                                                <div onClick={() => openModal(imageUrl)} className="size-10 rounded-lg bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 cursor-pointer overflow-hidden group relative">
                                                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                                                                        <span className="material-symbols-outlined text-white opacity-0 group-hover:opacity-100 text-sm">
                                                                            visibility
                                                                        </span>
                                                                    </div>
                                                                    <img
                                                                        src={imageUrl}
                                                                        alt="Proof"
                                                                        className="w-full h-full object-cover"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td> */}
                                                </tr>
                                            </>
                                        )
                                    }) : ""}
                                </tbody>
                            </table>
                        )}
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-4 sm:px-6 py-4">
                    <PageEntries
                        start={start}
                        end={end}
                        totalCount={totalCount}
                    />

                    <PaginationButtons
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        goToPage={goToPage}
                        pages={pages}
                        hasNextPage={hasNextPage}
                        fetchNextPage={fetchNextPage}
                    />
                </div>
                {selectedImage && (
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
                        onClick={closeModal}
                    >
                        <div
                            className="relative max-w-5xl max-h-[90vh] w-full h-full rounded-xl overflow-hidden shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Close button */}
                            <button
                                className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
                                onClick={closeModal}
                                aria-label="Close modal"
                            >
                                <span className="material-symbols-outlined">close</span>
                            </button>

                            {/* Image */}
                            <img
                                src={selectedImage}
                                alt="Full size shop close proof"
                                className="w-full h-full object-contain bg-slate-900"
                                onError={(e) => {
                                    e.target.src = '/fallback-large-placeholder.jpg';
                                }}
                            />
                        </div>
                    </div>
                )}
                {/* Footer / Load more */}

            </div>
        </div>
    )
}

export default DetailsActionHistoryReport
